module.exports = __webpack_public_path__ + "static/img/banner-en.5d60e259.webp";